import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nConfig, provideConfig } from '@spartacus/core';
import { CustomManufacturerCampaignModule } from './custom-manufacturer-campaign/custom-manufacturer-campaign.module';
import { CustomOrderHistoryModule } from './custom-order-history/custom-order-history.module';
import { CustomStatisticModule } from './custom-statistic/custom-statistic.module';
import { CustomStockProtectionModule } from './custom-stock-protection/custom-stock-protection.module';
import { CustomUserPaymentsModule } from './custom-user-payments/custom-user-payments.module';
import { DeliveryNotesModule } from './delivery-notes/delivery-notes.module';
import { CustomVendorReportingModule } from './custom-vendor-reporting/custom-vendor-reporting.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CustomOrderHistoryModule,
    DeliveryNotesModule,
    CustomStockProtectionModule,
    CustomUserPaymentsModule,
    CustomStatisticModule,
    CustomManufacturerCampaignModule,
    CustomVendorReportingModule
  ],
  providers: [
    DatePipe,
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: { uigMyAccount: ['customOrderHistory', 'customStockProtection', 'customUserPayments', 'deliveryNotes', 'statistic','customManufacturerCampaign','customVendorReporting'] },
      },
    }),
  ],
})
export class UigMyAccountModule { }
